import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import {
  BeforeYouStart,
  IssueType,
  PhotoUpload,
  DateOfAdIssue,
  DateOfChangeIssue,
  DateOfInstallationIssue,
  DateOfWorksIssue,
  DateOfBreachIssue,
  DateOfShortTermLetsIssue,
  PlanningPermission,
  TellUsMoreAd,
  TellUsMoreChange,
  TellUsMoreInstallation,
  TellUsMoreWorks,
  TellUsMoreBreach,
  IsAdLitUp,
  DoesOwnerLiveAtProperty,
  AdResponsibility,
  ChangeResponsibility,
  InstallationResponsibility,
  WorksResponsibility,
  ShortTermLetsResponsibility,
  AdProblem,
  ChangeProblem,
  InstallationProblem,
  WorksProblem,
  BreachProblem,
  ShortTermLetsProblem,
  PropertyUsage,
  ShortTermLetsAd,
  WorksCompleted,
  AnyMoreInfo,
  EmailConfirmationReport,
  ContactUserOption,
  YourDetails,
  Confirmation,
  IssueLocation,
} from './components/pages';
import { RoutesList, steps } from '../routes/Routes';
import { basename } from '../routes/basename';
import { useEffect } from 'react';
import { useScrollToTop } from '@shared/hooks';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  useScrollToTop();

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route
            path={RoutesList.PLANNING_BREACH_HOME}
            element={<BeforeYouStart />}
          />
          <Route path={RoutesList.PHOTO_UPLOAD} element={<PhotoUpload />} />
          <Route path={RoutesList.ISSUE_LOCATION} element={<IssueLocation />} />

          <Route path={RoutesList.ISSUE_TYPE} element={<IssueType />} />
          <Route
            path={RoutesList.ADVERTISEMENT_DATE}
            element={<DateOfAdIssue />}
          />
          <Route
            path={RoutesList.CHANGE_DATE}
            element={<DateOfChangeIssue />}
          />
          <Route
            path={RoutesList.INSTALLATION_DATE}
            element={<DateOfInstallationIssue />}
          />
          <Route path={RoutesList.WORKS_DATE} element={<DateOfWorksIssue />} />
          <Route
            path={RoutesList.BREACH_DATE}
            element={<DateOfBreachIssue />}
          />
          <Route
            path={RoutesList.SHORT_TERM_LETS_DATE}
            element={<DateOfShortTermLetsIssue />}
          />
          <Route
            path={RoutesList.PLANNING_PERMISSON}
            element={<PlanningPermission />}
          />
          <Route path={RoutesList.PROPERTY_USAGE} element={<PropertyUsage />} />
          <Route path={RoutesList.TELL_US_MORE_AD} element={<TellUsMoreAd />} />
          <Route
            path={RoutesList.TELL_US_MORE_CHANGE}
            element={<TellUsMoreChange />}
          />
          <Route
            path={RoutesList.TELL_US_MORE_INSTALLATION}
            element={<TellUsMoreInstallation />}
          />
          <Route
            path={RoutesList.TELL_US_MORE_WORKS}
            element={<TellUsMoreWorks />}
          />
          <Route
            path={RoutesList.TELL_US_MORE_BREACH}
            element={<TellUsMoreBreach />}
          />
          <Route path={RoutesList.IS_AD_LIT_UP} element={<IsAdLitUp />} />
          <Route
            path={RoutesList.OWNER_LIVE_AT_PROP}
            element={<DoesOwnerLiveAtProperty />}
          />
          <Route
            path={RoutesList.AD_RESPONSIBILITY}
            element={<AdResponsibility />}
          />
          <Route
            path={RoutesList.CHANGE_RESPONSIBILITY}
            element={<ChangeResponsibility />}
          />
          <Route
            path={RoutesList.INSTALLATION_RESPONSIBILITY}
            element={<InstallationResponsibility />}
          />
          <Route
            path={RoutesList.WORKS_RESPONSIBILITY}
            element={<WorksResponsibility />}
          />
          <Route
            path={RoutesList.SHORT_TERM_LETS_RESPONSIBILITY}
            element={<ShortTermLetsResponsibility />}
          />
          <Route path={RoutesList.AD_PROBLEM} element={<AdProblem />} />
          <Route path={RoutesList.CHANGE_PROBLEM} element={<ChangeProblem />} />
          <Route
            path={RoutesList.INSTALLATION_PROBLEM}
            element={<InstallationProblem />}
          />
          <Route path={RoutesList.WORKS_PROBLEM} element={<WorksProblem />} />
          <Route path={RoutesList.BREACH_PROBLEM} element={<BreachProblem />} />
          <Route
            path={RoutesList.SHORT_TERM_LETS_PROBLEM}
            element={<ShortTermLetsProblem />}
          />
          <Route
            path={RoutesList.SHORT_TERM_LETS_AD}
            element={<ShortTermLetsAd />}
          />
          <Route
            path={RoutesList.WORKS_COMPLETED_DATE}
            element={<WorksCompleted />}
          />
          <Route path={RoutesList.ANY_MORE_INFO} element={<AnyMoreInfo />} />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION_REPORT}
            element={<EmailConfirmationReport />}
          />
          <Route
            path={RoutesList.CONTACT_USER_OPTION}
            element={<ContactUserOption />}
          />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};
export default App;
